import { useEffect, useState } from 'react';
import Landing from './pages/Landing';
import OnePager from './pages/OnePager';
import Deck from './pages/Deck';
import { ONEPAGER_TOKEN, DECK_TOKEN } from './lib/links';

/**
 * Path-based routing with hidden-route gating.
 *
 * /                                 → Landing (always)
 * /onepager/<ONEPAGER_TOKEN>        → OnePager
 * /deck/<DECK_TOKEN>                → Deck
 * everything else, including bare   → Landing (silent)
 *   /onepager and /deck without
 *   the right token
 *
 * Trailing slashes are tolerated. Anything else falls through to Landing
 * so nobody discovers that the hidden routes exist. Real protection
 * isn't possible client-side; treat the tokens as unguessable URLs.
 */
function getRoute(): 'home' | 'onepager' | 'deck' {
  const p = window.location.pathname;
  if (
    p === `/onepager/${ONEPAGER_TOKEN}` ||
    p === `/onepager/${ONEPAGER_TOKEN}/`
  ) {
    return 'onepager';
  }
  if (
    p === `/deck/${DECK_TOKEN}` ||
    p === `/deck/${DECK_TOKEN}/`
  ) {
    return 'deck';
  }
  return 'home';
}

export default function App() {
  const [route, setRoute] = useState<ReturnType<typeof getRoute>>(getRoute);

  useEffect(() => {
    const onPop = () => setRoute(getRoute());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  if (route === 'onepager') return <OnePager />;
  if (route === 'deck') return <Deck />;
  return <Landing />;
}
